import qs from 'qs';

import { MayBeNil } from 'app/@types/utils/may-be-nil';

const ROOT = '/';
const BASE = '/search';

type Numeric = number | string;

export const ROUTES = {
    ROOT: () => ROOT,
    SEARCH: () => BASE,
    TYPES_CVE: (options: { page?: MayBeNil<Numeric>; type: string; order?: MayBeNil<string> }) => {
        const parts = [BASE, 'types', options.type, options.order, options.page && `page/${options.page}`];

        return parts.filter(Boolean).join('/');
    },
    VENDORS: (options?: {
        page?: MayBeNil<Numeric>;
        letter?: MayBeNil<string>;
        search?: MayBeNil<string>;
        size?: MayBeNil<Numeric>;
        sort?: MayBeNil<object>;
    }) => {
        const parts = [
            BASE,
            'vendors',
            options?.letter && `index/${options.letter}`,
            options?.page && `page/${options.page}`
        ];
        const search = qs.stringify(
            { size: options?.size, search: options?.search, sort: options?.sort },
            { addQueryPrefix: true, skipNulls: true }
        );

        return parts.filter(Boolean).join('/').concat(search);
    },
    VENDOR: (options: {
        vendor: string;
        page?: MayBeNil<Numeric>;
        size?: MayBeNil<Numeric>;
        letter?: MayBeNil<string>;
        search?: MayBeNil<string>;
        sort?: MayBeNil<object>;
        score?: MayBeNil<Numeric>;
        year?: MayBeNil<Numeric>;
        month?: MayBeNil<Numeric>;
    }) => {
        const parts = [
            BASE,
            'vendors',
            options.vendor,
            options?.letter && `index/${options.letter}`,
            options.page && `page/${options.page}`
        ];
        const search = qs.stringify(
            {
                score: options.score,
                year: options.year,
                month: options.month,
                size: options.size,
                search: options?.search,
                sort: options?.sort
            },
            { addQueryPrefix: true, skipNulls: true }
        );

        return parts.filter(Boolean).join('/').concat(search);
    },
    PRODUCTS: (options?: {
        page?: MayBeNil<Numeric>;
        letter?: MayBeNil<string>;
        size?: MayBeNil<Numeric>;
        search?: MayBeNil<string>;
        sort?: MayBeNil<object>;
    }) => {
        const parts = [
            BASE,
            'products',
            options?.letter && `index/${options.letter}`,
            options?.page && `page/${options.page}`
        ];
        const search = qs.stringify(
            { size: options?.size, search: options?.search, sort: options?.sort },
            { addQueryPrefix: true, skipNulls: true }
        );

        return parts.filter(Boolean).join('/').concat(search);
    },
    PRODUCT_VERSIONS: (options: {
        page?: MayBeNil<Numeric>;
        vendor: string;
        product: string;
        score?: MayBeNil<Numeric>;
        year?: MayBeNil<Numeric>;
        month?: MayBeNil<Numeric>;
        size?: MayBeNil<Numeric>;
        search?: MayBeNil<string>;
        sort?: MayBeNil<object>;
    }) => {
        const parts = [
            BASE,
            'vendors',
            options.vendor,
            'products',
            options.product,
            'versions',
            options.page && `page/${options.page}`
        ];
        const search = qs.stringify(
            {
                score: options.score,
                year: options.year,
                month: options.month,
                size: options.size,
                search: options?.search,
                sort: options?.sort
            },
            { addQueryPrefix: true, skipNulls: true }
        );

        return parts.filter(Boolean).join('/').concat(search);
    },
    PRODUCT_CVES: (options: {
        vendor: string;
        product: string;
        page?: MayBeNil<Numeric>;
        version?: MayBeNil<string>;
        score?: MayBeNil<Numeric>;
        year?: MayBeNil<Numeric>;
        month?: MayBeNil<Numeric>;
    }) => {
        const parts = [
            BASE,
            'vendors',
            options.vendor,
            'products',
            options.product,
            options.version && `versions/${options.version}`,
            options.page && `page/${options.page}`
        ];
        const search = qs.stringify(
            { score: options.score, year: options.year, month: options.month },
            { addQueryPrefix: true, skipNulls: true }
        );

        return parts.filter(Boolean).join('/') + search;
    },
    YEARS: (options?: {
        page?: MayBeNil<Numeric>;
        year?: MayBeNil<Numeric>;
        month?: MayBeNil<Numeric>;
        size?: MayBeNil<Numeric>;
        sort?: MayBeNil<object>;
    }) => {
        const parts = [
            BASE,
            'years',
            options?.year && `year/${options.year}`,
            options?.month && `month/${options.month}`,
            options?.page && `page/${options.page}`
        ];
        const search = qs.stringify(
            { size: options?.size, sort: options?.sort },
            { addQueryPrefix: true, skipNulls: true }
        );

        return parts.filter(Boolean).join('/').concat(search);
    },
    CVSS: (options?: {
        page?: MayBeNil<Numeric>;
        cvss?: MayBeNil<string>;
        size?: MayBeNil<Numeric>;
        sort?: MayBeNil<object>;
    }) => {
        const search = qs.stringify(
            { size: options?.size, sort: options?.sort },
            { addQueryPrefix: true, skipNulls: true }
        );
        const parts = [BASE, 'cvss', options?.cvss && `score/${options.cvss}`, options?.page && `page/${options.page}`];

        return parts.filter(Boolean).join('/').concat(search);
    },
    TAGS: (options: { tag: string }) => {
        const parts = [BASE, 'tags', options.tag];
        return parts.filter(Boolean).join('/');
    }
} as const;

export const NONE = '—';
export const WILDCARD = '*';
